module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x30-251d02ffede00c19aa9db4025e62642b.png";